<template>
	<div style="width: 100%;background: #fff;">
		<div class="d-flex p-2" style="align-items: center;">
			<div style="font-size: 14px;" class="mr-2">截至日期</div>
			<el-date-picker v-model="value1" type="date" placeholder="选择日期" class="mr-2" size="mini"></el-date-picker>
			<el-button type="primary" size="mini">查询</el-button>
		</div>
		<div class="csss">
			<el-table :data="tableData" style="width: 100%" size="mini" show-summary>
				<el-table-column  prop="id" width="80" label="No."></el-table-column>
				<el-table-column  prop="name" label="账户名称"></el-table-column>
				<el-table-column  prop="address" align="right" label="初始金额" sortable></el-table-column>
				<el-table-column  prop="address" align="right" label="流入金额" sortable></el-table-column>
				<el-table-column  prop="address" align="right" label="流出金额" sortable></el-table-column>
				<el-table-column  prop="address" align="right" label="余额" sortable></el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	// 引入注册
	components: {
		buttonSearch
	},
	data() {
		return {
			kon:'',
			value1: '',
			tableData: [
				{
					id:1,
					name: '默认账户',
					address: '0'
				},
				{
					id:2,
					name: '现金',
					address: '355215.02'
				},
				{
					id:3,
					name: '银行【对公】',
					address: '355215.02'
				},
				{
					id:4,
					name: '支付宝',
					address: '355215.02'
				},
				{
					id:5,
					name: '微信',
					address: '355215.02'
				},
				{
					id:6,
					name: '固定资产',
					address: '355214'
				},
				{
					id:7,
					name: '应收款',
					address: '355215.02'
				},
				{
					id:8,
					name: '应付款',
					address: '355215.02'
				},
				{
					id:9,
					name: '预收款',
					address: '355214'
				},
				{
					id:10,
					name: '预付款',
					address: '355215.02'
				},
				{
					id:11,
					name: '库存商品',
					address: '355215.02'
				},
				{
					id:12,
					name: '利润',
					address: '355214'
				}
			],
		};
	},

	methods: {},
};
</script>

<style>
	.csss .el-table__footer-wrapper .cell {
    color: #ff6a00;
    font-weight: bold;
    font-size: 13px;
}
</style>
